<template>
    <modal class="aiAddItemConfirmModel" :isShow="isShow" @keyup.esc="hide">
        <div class="header">AI点菜确认信息 </div>
        <div class="modal-body">
            <div class="li-flex">
                <span class="lable-text">菜名:</span>
                <div class="from-input">{{food?.Food_Name}}</div>
            </div>
            <div class="li-flex">
                <div class="flex-1">
                    <span class="lable-text">数量:</span>
                    <div class="from-input">
                        <key-board-input v-model="number" 
                            pattern="number" :dplaces="3" :min="0" 
                            :keyOptions="{isNumber:true,isKeyDownEnter:true}"
                            isBlurClose isKeyEnterClose @click="stopCountDown"/>
                    </div>
                </div>
                <div class="flex-1">
                    <span class="lable-text">单价:</span>
                    <div class="from-input">￥{{food?.Food_Price}}/{{food?.Food_Size}}</div>
                </div>
            </div>
            <div class="li-flex">
                <span class="lable-text">小计:</span>
                <div class="from-input money"><span class="unit">¥</span>{{money}}</div>
            </div>
        </div>
        <div class="footer-box">
            <button class="btn" @click="hide()">返回</button>
            <button class="btn selected" @click="confirm()">确认
                <div :style="{display:countdown>0?'inline-block':'none'}">
                    (<count-down :isStart="countdown>0" :duration="countdown" unit="秒" @success="confirm" />)
                </div>
            </button>
        </div>
    </modal>
</template>

<script>
// AI点菜确认信息
export default {
    name:'aiAddItemConfirmModel',
    emits:["close","confirm"],
    props:{
        isShow:Boolean,
        //传入的数据
        data:{
            type:Object,
            default:null
        },
        /**点菜界面横向数量键盘  数量 */
        orderNumber:{
            type:[Number,String],
            default:null
        },
        /**电子秤 称重 数量 */
        wgNum:{
            type:Number,
            default:null
        }
    },
    data(){
        return{
            //菜品
            food:null,
            //倒计时
            countdown:0,
            number:0,
        }
    },
    mounted(){
        this.init();
    },
    computed:{
        //小计金额
        money(){
            if(this.food){
                return Number(this.number).compute(this.food.Food_Price,"*");
            }
            return 0;
        },
        /**默认数量 */
        defaultNumber(){
            let num=1;
            if(Number(this.orderNumber)>0){
                num=Number(this.orderNumber);
            }else if(this.isUnitWeight(this.data?.food?.Food_Size) && Number(this.wgNum)>0){
                num=Number(this.wgNum);
            }else if(Number(this.data?.food?.Eat_Number)>0){//本身有数量
                num=Number(this.data?.food?.Eat_Number);
            }
            return num;
        }
    },
    watch:{
        isShow(newValue){
            if(newValue){
                this.init();
            }
        },
        defaultNumber(newVal,oldVal){
            if(this.number==oldVal){//非手动修改的 随称重变动
                this.number=newVal;
            }
        }
    },
    methods:{
        hide(){
            this.$emit("close");
            
        },
        init(){
            this.food=null;
            this.countdown=0;
            this.number=this.defaultNumber;
            console.log("Eat_Number：",this.number)
            if(this.data){
                this.food=this.data.food;
                this.countdown=this.data.countdown;
            }
            
        },
        /**是否标准称重单位 */
        isUnitWeight(unit){
            if(unit=="斤" || unit=="公斤" || unit=="克" || unit=="市斤" || (unit||"").toUpperCase() =="KG" || (unit||"").toUpperCase()=="G" ){
                return true;
            }
            return false;
        },
        /**点击数量 去修改 暂停倒计时确定 */
        stopCountDown(){
            this.countdown=0;
        },
        confirm(){
            this.countdown=0;
            if(this.number<=0){
                this.$message.warning('请输入数量！');
                return;
            }
            this.$emit("confirm",Object.assign({},this.food,{
                Eat_Number:this.number
            }))
        }
    }
}
</script>

<style lang="scss">
.aiAddItemConfirmModel{
    font-size: 12px;
    color: #000000;

    .modal-dialog{ 
        width: 500px;
        max-width: 500px;
       
        .modal-content{
            right: inherit;
            width: 100%;
            border-radius: 8px;
            padding-bottom: 24px;
        }
    }
 
    .header{
        background: #DCE2EA;
        height: 42px;
        line-height: 42px;
        padding-left: 20px;
        border-radius: 8px;
        border-bottom-left-radius:0 ;
        border-bottom-right-radius:0 ;
        font-size: 15px;
        color: #333333;
    }

    .flex-box{
        display: flex;
    } 

    .modal-body{
        padding:8px 20px;
        padding-bottom: 20px;
        font-size: 14px;
        
        .li-flex{
            display: flex;
            align-items: baseline;
            margin: 10px 0;

            .flex-1{
                flex:1;
                overflow: hidden;
                display:flex;
                align-items: baseline;
            }

            .lable-text{
                width: 60px;
                margin-right: 10px;
                text-align: right;
                color: #666;
            }

            .from-input{
                flex:1;
                font-size: 30px;
                color: #000;

                &.money{
                    color: #f00;
                    font-size: 30px;

                    .unit{
                        font-size: 20px;
                    }
                }

                .keyBoardInput{
                    input{
                        border:0;
                        box-shadow: none;
                        font-size: 30px;
                    }

                    .jianpan{
                        font-size: 35px;
                    }
                }
            }
        }
    }

    .footer-box{
        padding: 0 10px;
        text-align: center;
        display: flex;
        justify-content: center;

        .btn{
            background: #E8E8E8;
            border: 1px solid #D5D7DB;
            border-radius: 4px;
            min-width: 60px;
            height: 40px;
            line-height: 40px;
            font-size: 16px;
            color: #487BB1;
            padding: 0 8px;
            margin: 0 10px;
            flex-grow: 1;
            

            &.selected{
                background: #487BB1;
                color:#fff;
            }

            .countDown{
                display: inline-block;
            }
        }
    }
}
</style>